export { default } from './CheckedOutAdditionalBriefInfo';



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutAdditionalBriefInfo/index.js